import React from "react";
import { connect } from "react-redux";
import s from "./Header.css";
import { Link } from "../../components";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import { PRODUCT_ROUTE, LOGOUT_ROUTE, USER_ROUTE, USER_PREFERENCES } from "../../routes";
import { changeCurrency, setInitialCurrencies } from "../../reducers/global";
import { updateUserPreferences, setSessionCurrency } from "../../reducers/user";
import { Dropdown, Icon, Layout, Menu, Tooltip, Select, Popconfirm } from "antd";
import messages from "./messages";
import { injectIntl } from "react-intl";
const { SubMenu } = Menu;
const { Sider, Header2, Content } = Layout;
const TooltipDelay = 0.5;
import { version } from "../../version";
import PropTypes from "prop-types";
import { hasFeature } from "../../utils";
import history from "../../history";
import { clearForms } from "../../reducers/product";

class Header extends React.Component {
  static propTypes = {
    // user: PropTypes.object.isRequired,
    // currency: PropTypes.object.isRequired,
    // sessionCurrency: PropTypes.object.isRequired,
    // selectedProduct: PropTypes.object.isRequired,
    // setSessionCurrency: PropTypes.object.isRequired,
    // changeCurrency: PropTypes.object.isRequired,
    // currencies: PropTypes.object.isRequired,
    // intl: PropTypes.object.isRequired,
    // currentRouteName: PropTypes.object.isRequired,
    // apiUrl: PropTypes.object.isRequired,
    // toggleSider: PropTypes.object.isRequired,
    // setInitialCurrencies: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      width: 0,
      user_image: null,
    };
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {}

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  render() {
    const { user, intl, currentRouteName, apiUrl } = this.props;

    // public tutorials
    let user_name = "";
    if (user) {
      // internal tutorials
      if (user.first_name) {
        if (user.last_name) {
          user_name = `${user.first_name} ${user.last_name}`;
        } else {
          user_name = `${user.first_name}`;
        }
      } else {
        user_name = user.email;
      }
    }

    const handleLogout = () => {
      var widget = document.getElementById("searchie-fixed-btn");
      if (widget) widget.parentNode.removeChild(widget);
      var script = document.getElementById("widget_script-fixed-btn");
      if (script) script.parentNode.removeChild(script);
    };

    const handlePreferencesLink = () => {
      this.props.clearForms(this.props.productnavref);
      history.push("/preferences");
    };

    const handleAccountLink = () => {
      this.props.clearForms(this.props.productnavref);
      history.push("/account");
    };

    let is_product_path = null;
    if (history && history.location && history.location.pathname && /\/product|cosmode/.test(history.location.pathname)) {
      is_product_path = true;
    }

    const onlyAIAssistant = hasFeature(user, "aiassistant") && !hasFeature(user, "aromatherapy");

    return (
      <Layout.Header className={s.header}>
        <div className={s.rightMenu}>
          <span className={s.rainbow}>AI GRIMM SOCIETY</span>
        </div>
      </Layout.Header>
    );
  }
}

const mapState = (state) => ({
  currency: state.global.currency,
  currencies: state.global.currencies,
  sessionCurrency: state.user.sessionCurrency,
  currentRouteName: state.global.currentRouteName,
  user: state.user.user,
  apiUrl: state.global.apiUrl,
  selectedProduct: state.product.selectedProduct,
  selectedRawMaterials: state.rawMaterials.selectedRawMaterials,
  sessionCurrency: state.user.sessionCurrency,
  productnavref: state.product.productnavref,
});

const mapDispatch = {
  changeCurrency,
  updateUserPreferences,
  setSessionCurrency,
  clearForms,
  setInitialCurrencies,
};

export default injectIntl(connect(mapState, mapDispatch)(withStyles(s)(Header)));
